import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ItemDetail } from '../../../types/item-detail';

import {
  IconComponent,
  CardComponent,
  BadgeComponent,
  ToolTipDirective,
} from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-listung',
  imports: [
    CdkAccordionModule,
    IconComponent,
    TranslatePipe,
    CardComponent,
    BadgeComponent,
    ToolTipDirective,
  ],
  templateUrl: './listung.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Listung {
  readonly data = input.required<ItemDetail | null>();
  readonly expanded = input.required<boolean>();

  readonly listings = computed(() => {
    const listings = new Set<string>();
    return (this.data()?.itemVkforg ?? [])
      .filter((v) => {
        if (listings.has(v.listing.kzgelistet)) return false;
        listings.add(v.listing.kzgelistet);
        return true;
      })
      .map((v) => v.listing);
  });
}
